export default "__VITE_ASSET__CZtZQcnG__"